import Swiper, { Navigation, Autoplay, A11y, EffectCoverflow } from 'swiper';
Swiper.use([Navigation, Autoplay, A11y, EffectCoverflow]);

// Portal filters
let featuredSwiper;
let featuredSwiperWrapper;
let featuredOffers = [];

let swiperOptions = {
  effect: 'coverflow',
  centeredSlides: true,
  loop: true,
  speed: 500,
  slidesPerView: 1,
  spaceBetween: 20,
  autoplay: {
    delay: 5000,
    pauseOnMouseEnter: true,
    disableOnInteraction: false,
  },
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 200,
    modifier: 1,
    slideShadows: false,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  a11y: {
    enabled: true,
  },
  breakpoints: {
    767: {
      slidesPerView: 2,
    },
  },
}

if (jQuery('.swiper-featured').length) {
  let offersRaw = jQuery('.swiper-featured .swiper-slide');
  offersRaw.each(function() {
    let offer = jQuery(this);
    featuredOffers.push(offer.data())
  });

  featuredSwiper = new Swiper('.swiper-featured', swiperOptions);
  featuredSwiperWrapper = jQuery(featuredSwiper.el).find('.swiper-wrapper');
}

let portalCats = jQuery('.portal__sidebar__top-level');
let portalOffers = jQuery('.portal__offers .portal__offers__item');
let portalSubcats = jQuery('.portal__sidebar__subcat');
let portalSidebar = jQuery('#portalSidenav');

if (portalCats.length) {
  portalCats.each(function() {
    let portalCat = jQuery(this);
    portalCat.click(function() {
      let id = portalCat.data().id;

      if(id === 'all') {
        portalOffers.each(function() {
          let portalOffer = jQuery(this);
          portalOffer.css('display', 'block');
        });
        portalCat.addClass('active');
        rebuildSwiper(id);
        closeRemaining(id);
        return;
      }

      let subcats = jQuery(`.portal__sidebar__subcats[data-parent="${id}"]`);
      if (portalCat.attr('aria-expanded') === 'true') {
        portalCat.attr('aria-expanded', 'false');
        portalCat.removeClass('active');
        subcats.removeClass('open');
        subcats.css('max-height', 0);
      } else {
        portalCat.attr('aria-expanded', 'true');
        portalCat.addClass('active');
        subcats.addClass('open');
        subcats.css('max-height', subcats[0].scrollHeight);
        closeRemaining(id);
      }

      toggleOffers(id);
      rebuildSwiper(id);
    });
  });

  portalSubcats.each(function() {
    let portalSubcat = jQuery(this);
    portalSubcat.click(function() {
      let id = portalSubcat.data().id;
      toggleOffers(id);
      rebuildSwiper(id);
      closeSidebar();
    });
  });
}

function toggleOffers(open_id) {
  portalOffers.each(function() {
    let portalOffer = jQuery(this);
    let offerCats = typeof portalOffer.data().cats === 'number' ? [portalOffer.data().cats.toString()] :  portalOffer.data().cats.split(',');
    if (offerCats.includes(open_id.toString())) {
      portalOffer.css('display', 'block');
    } else {
      portalOffer.css('display', 'none');
    }
  });
}

function rebuildSwiper(open_id) {
  featuredSwiper.destroy();
  featuredSwiperWrapper.empty();

  for(let i = 0; i < 6; i++) {
    featuredOffers.forEach(function(featuredOffer) {
      let offerCats = typeof featuredOffer.cats === 'number' ? [featuredOffer.cats.toString()] : featuredOffer.cats.split(',');
      if (open_id === 'all' || offerCats.includes(open_id.toString())) {
        featuredSwiperWrapper.append(`
          <a href="${featuredOffer.pdf}" class="swiper-slide portal__offers__item" target="_blank">
            <div class="rectangular-image">
              <img src="${featuredOffer.img}" alt="" />
            </div>
            <h3 class="mb-0">${featuredOffer.title}</h3>
          </a>
        `);
      }
    });
  }

  featuredSwiper = new Swiper('.swiper-featured', swiperOptions);
  if(featuredSwiper.slides.length) {
    jQuery('.portal__featured').removeClass('hide');
  } else {
    jQuery('.portal__featured').addClass('hide');
  }
}

function closeRemaining(open_id) {
  portalCats.each(function() {
    let portalCat = jQuery(this);
    let id = portalCat.data().id;
    if (open_id !== id) {
      let subcats = jQuery(`.portal__sidebar__subcats[data-parent="${id}"]`);
      portalCat.removeClass('active');
      portalCat.attr('aria-expanded', 'false');
      subcats.removeClass('open');
      subcats.css('max-height', 0);
    }
  });
}

function closeSidebar() {
  if (portalSidebar.hasClass('open')) {
    portalSidebar.removeClass('open');
    jQuery('body').css('overflow', 'auto');
    jQuery('.portal__burger-menu').each(function() {
      jQuery(this).attr('aria-expanded', false);
    });
  }
}
